export const getPayload = ({ name, lastName, image, username, email }) => {
  const form = new FormData()

  if (image?.file) form.append('profile_picture', image?.file)
  form.append('first_name', name)
  form.append('last_name', lastName)
  form.append('username', username)
  form.append('email', email)

  return form
}
